export const GLOBAL_TOOLTIP_ID = 'global-tooltip'
export const GLOBAL_TOOLTIP_CONTENT_ID = `${GLOBAL_TOOLTIP_ID}-content`
